jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.testimonials').length ) {
        let $ = jQuery;
        $(".testimonials .testimonials-slider .slides").slick({
            arrows: false,
            dots: true,
            fade: true
        });
    }
    if( jQuery('section.testimonials-full-width').length ) {
        let $ = jQuery;
        $(".testimonials-full-width .testimonials-slider .slides").slick({
            arrows: true,
            dots: true,
            fade: true
        });
    }
});